import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { ButtonGroup, Button } from 'reactstrap';
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import UserForm from '../UserForm/UserForm';
import { PageTitle, Loader } from '../../../components';
import { loadUser, updateUser, toggleUserStatus, setMessagesUsersIds, spoof } from '../../../redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

import './UserEdit.css';

const UserEdit = ({id}) => {
    const dispatch    = useDispatch();
    const { t }       = useTranslation();
    const history     = useHistory();

    const current_user              = useSelector(state => state.auth.user)
    const [activeTab, setActiveTab] = useState('1');
    const {
        user,
        isLoading,
        templateApplied,
        hasLoadingError
    } = useSelector(state => state.users)

    let userId = useParams('userId').userId;
    if (id)
        userId = id;

    useEffect(() => {
        if (userId)
            dispatch(loadUser(userId));
    }, [])

    useEffect(() => {
        if (userId)
            dispatch(loadUser(userId));
    }, [userId])

    if (!user || (user.id !== userId) || !current_user || hasLoadingError)
        return <Loader />;

    const submit = (values) => {
        dispatch(updateUser(values));
    }

    const sendEmail = () => {
        dispatch(setMessagesUsersIds([ user.id ]));
        history.push('/messages');
    };

    const spoofUser = () => {
        dispatch(spoof(user.id));
    };

    const title = current_user.id === user.id ?
        <span>{t('users.update_my_profile')}</span>
        :
        <span>
            {t('users.user', {count: 1})}
            <small> | {t('users.update_user', {firstname: user.firstname, lastname: user.lastname})}</small>
        </span>

    const actions = (
        <div>
            {user &&
                <ButtonGroup>
                    <Button onClick={ () => window.history.back() } color="warning" size="sm">
                        <i className="fa fa-arrow-left"></i>&nbsp;
                        {t('common.back')}
                    </Button>
                    {user.is_active && current_user.can('disable', 'users') && current_user.id !== user.id &&
                        <Button disabled={isLoading} color='danger' size="sm" onClick={ () => { dispatch(toggleUserStatus(user)); }}>
                            <i className={isLoading ? 'fa fa-spinner fa-spin' : 'fa fa-pause'}></i>&nbsp;
                            {t('users.disable')}
                        </Button>
                    }
                    {!user.is_active && current_user.can('enable', 'users') && current_user.id !== user.id &&
                        <Button disabled={isLoading} color='success' size="sm" onClick={ () => { dispatch(toggleUserStatus(user)); }}>
                            <i className={isLoading ? 'fa fa-spinner fa-spin' : 'fa fa-play'}></i>&nbsp;
                            {t('users.enable')}
                        </Button>
                    }
                    {current_user.can('create', 'messages') && (current_user.id !== user.id) &&
                        <Button onClick={ sendEmail } color="primary">
                            <i className="fa fa-envelope" />&nbsp;
                            { t('tickets.batch.send_email') }
                        </Button>
                    }
                    {current_user.can('spoof', 'users') && current_user.id !== user.id &&
                        <Button onClick={ spoofUser } color="warning">
                            <i className="fa fa-user-secret" />&nbsp;
                            { t('users.spoof') }
                        </Button>
                    }
                </ButtonGroup>
            }
        </div>
    );

    return (
        <div className="UserEdit">
            <PageTitle icon="users" title={ title } actions={ actions } />

            {user && current_user &&
                <UserForm
                    onSubmit={submit}
                    authUser={current_user}
                    user={user}
                    templateApplied={templateApplied}
                    isLoading={isLoading}
                    _activeTab={activeTab}
                    onActiveTab={setActiveTab}
                />
            }
        </div>
    );
}

export default UserEdit;
